// extracted by mini-css-extract-plugin
export default {"verificationBannerItem":"VerifyEmail_verificationBannerItem__llOLe","verificationAcrLogo":"VerifyEmail_verificationAcrLogo__unMOS"};